<template>
    <div class="mt-5">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Dialogue avec votre office de tourisme
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="panel" v-if="!disabled">
                <div class="panel-heading">
                    Pour toutes informations ou demandes que vous souhaiteriez transmettre à votre office de tourisme
                </div>

                <div class="panel-body">
                    <v-textarea class="textarea" :value="extra" @change="setExtra" :readonly="disabled" placeholder="- Nouvelles offres/tarifs
- Demandes diverses
- ..." outlined>
                    </v-textarea>
                </div>

            </div>

            <div class="panel" v-if="!disabled">
                <div class="panel-heading">Informations de la personne répondant</div>
                <div class="panel-body">
                    <v-text-field v-model="contact.first_name" label="Prénom" class="mb-2 required" autocomplete="new-first-name"
                        outlined>
                    </v-text-field>

                    <v-alert type="error"
                        v-if="submitted && (contact.first_name === null || contact.first_name === '')">
                        Le prénom est requis.
                    </v-alert>

                    <v-text-field v-model="contact.last_name" label="Nom" class="mb-2 required" autocomplete="new-last-name"
                        outlined>
                    </v-text-field>

                    <v-alert type="error" v-if="submitted && (contact.last_name === null || contact.last_name === '')">
                        Le nom est requis.
                    </v-alert>

                    <v-text-field v-model="contact.email" label="E-mail" class="required" autocomplete="new-email" outlined>
                    </v-text-field>

                    <v-alert type="error" v-if="submitted && (contact.email === null || contact.email === '')">
                        Le mail est requis.
                    </v-alert>

                    <v-alert type="error" v-if="submitted && !isValidEmail && contact.email !== ''">
                        Le format du mail n'est pas bon.
                    </v-alert>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import _ from "lodash"
import * as EmailValidator from 'email-validator'

export default {
    name: "Extra",
    methods: {
        ...mapMutations('web_form', [
            'setContact',
            'setExtra'
        ])
    },
    computed: {
        ...mapState('web_form', ['provider', 'contact', 'extra', 'submitted', 'disabled']),
        isValidEmail() {
            return EmailValidator.validate(this.contact.email)
        }
    },
    watch: {
        contact: {
            handler: _.debounce(function () {
                this.setContact(this.contact)
            }, 200),
            deep: true
        }
    },
}
</script>
